var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.046875,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.19027a164c102383ec8d683ce5ec7249.svg";
export { ForwardRef as ReactComponent };